import React from "react";

export default function PricingSwitch({ checked, onChange }) {
  return (
    <div
      onClick={onChange}
      style={{
        width: "20px",
        height: "12px",
        borderRadius: "12px",
        border: "1.4px solid #56585A",
        display: "flex",
        alignItems: "center",
        padding: "3.67px",
        cursor: "pointer",
        backgroundColor: "transparent",
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "5.5px",
          height: "5.5px",
          borderRadius: "50%",
          border: "1.4px solid #56585A",
          backgroundColor: "transparent",
          position: "absolute",
          left: "3px",
          transition: "transform 0.2s ease",
          transform: checked ? "translateX(5.7px)" : "translateX(0)",
          boxSizing: "border-box",
        }}
      />
    </div>
  );
}
